import { deleteMarca, getMarcasPanel } from "../../services/MarcasServices";
import { MarcasContext } from "./MarcasContext"

export const MarcasState = ({ children }) => {
    const getMarcasPanelData = async (search,numpag,filas) => {
        let res = await getMarcasPanel(search,numpag,filas)
        return res;
    }

    const deleteMarcaData = async (body,search,numpag,filas) => {
        const res = await deleteMarca(body)
        if (res) getMarcasPanelData(search,numpag,filas)
        return res
    }

    return <MarcasContext.Provider value={{
        deleteMarcaData,
        getMarcasPanelData,
    }} >
        {children}
    </MarcasContext.Provider>
}